import React from "react";
import { Play } from "lucide-react";

const videos = [
    {
        src: "/videos/video-1.mp4",
        poster: "https://images.unsplash.com/photo-1593429109417-c18f96abce98?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        title: "Preparação na hora",
        caption: "Polpa + água. 30 segundos.",
    },
    {
        src: "/videos/video-2.mp4",
        poster: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        title: "Sem cadeia de frio",
        caption: "Operação leve, em qualquer lugar.",
    },
];

export const VideoShowcase = () => {
    return (
        <section
            data-testid="video-showcase"
            className="py-20 md:py-28 bg-white relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                        Vê em ação
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl text-brand-ink leading-tight">
                        Mais rápido que pedir café.{" "}
                        <span className="text-brand-green">Mais natural que tudo.</span>
                    </h2>
                    <p className="mt-4 text-lg text-brand-ink-soft">
                        Vê o sistema a funcionar — sem cadeia de frio, sem complicações, sem
                        desperdício.
                    </p>
                </div>

                <div className="mt-12 grid md:grid-cols-2 gap-6 md:gap-8">
                    {videos.map((v, i) => (
                        <article
                            key={v.src}
                            data-testid={`video-card-${i}`}
                            className="group relative rounded-2xl overflow-hidden shadow-soft hover:shadow-pop transition-all duration-300"
                        >
                            <video
                                src={v.src}
                                poster={v.poster}
                                autoPlay
                                loop
                                muted
                                playsInline
                                preload="auto"
                                className="w-full aspect-[9/16] md:aspect-video object-cover bg-brand-ink"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/70 via-transparent to-transparent pointer-events-none" />
                            <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3 py-1.5">
                                <span className="h-2 w-2 rounded-full bg-brand-green animate-pulse" />
                                <span className="text-[11px] font-bold uppercase tracking-widest text-brand-ink">
                                    Live
                                </span>
                            </div>
                            <div className="absolute bottom-5 left-5 right-5 text-white">
                                <div className="font-display font-medium text-2xl">{v.title}</div>
                                <p className="text-sm opacity-90 mt-1">{v.caption}</p>
                            </div>
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-16 w-16 rounded-full bg-white/20 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                                <Play className="h-7 w-7 text-white ml-1" />
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
